<template>

    <div v-if="tag == 'div' && ready && elements.length > 0">
        <slot name="header" :elements="elements"></slot>

        <component :is="element.default" v-for="element in elements" :key="element.default.name" :context="element.context" v-model="content[element.default.name]" v-bind="$attrs" v-on="$listeners">
            <slot name="component" :context="element.context"></slot>
        </component>
        <slot name="footer" :elements="elements"></slot>
    </div>

    <component :is="tag" v-bind="$attrs" v-on="$listeners" v-else-if="tag != 'div' && ready && elements.length > 0">
        <slot :elements="elements"></slot>
    </component>

</template>

<script>
import listOfIntegrations from './index.js'

export default {
    name: "RenderEvent",
    props: {
        event: {
            type: String,
            default: ""
        },
        value: {
            type: Object,
            default: function() {
                return {}
            }
        },
        only: {
            type: String,
            default: ''
        },

        tag: {
            type: String,
            default: 'div'
        }
    },

    data: function() {
        return {
            elements: [],
            ready: false
        }
    },

    watch: {
        content: {
            handler(val) {
                this.$emit("input", val)
            },

            deep: true
        }
    },

    computed: {
        integrations() {
            if (this.only == '') {
                return this.$store.getters.getIntegrations
            }

            return this.$store.getters.getIntegrations.filter(i => {
                return i.id == this.only
            })
        },

        integrationsOnEvent() {
            return this.integrations.filter(i => {
                return i.template.renderevents.indexOf(this.event) !== -1
            })
        },

        content: {
            get() {
                return this.value
            },

            set(val) {
                this.$emit('input', val)
            }
        }
    },

    methods: {
        getEventsOfIntegration: (int) => {
            return listOfIntegrations[int.path];
        },

        renderElement(el) {
            return el.default
        }
    },

    async mounted() {
        await this.$store.dispatch('fetchIntegrations')

        if (this.content === null || this.content === undefined) {
            this.content = {}
        }

        this.integrationsOnEvent.forEach(i => {
            if (listOfIntegrations !== undefined) {
                listOfIntegrations[i.path]().then(c => {
                    const def = c.default[this.event]
                    if (def.component) {
                        if (def.permissions) {
                            for (const perm of def.permissions) {
                                if (!this.$can(`${perm} ${i.id}`)) {
                                    return
                                }
                            }
                        }
                        
                        def.component.then(c => {
                            this.elements.push({
                                ...c,
                                context: i
                            })
                        })
                    } else {
                        def.then(c => {
                            this.elements.push({
                                ...c,
                                context: i
                            })
                        })
                    }
                })
            }  
        })

        this.ready = true;
    }
}
</script>